import {CheckOutlined} from '@ant-design/icons';

type RegistrationOverviewStepProps = {
  title: string;
  stepNumber: number;
  disabled?: boolean;
  variant?: 'primary' | 'success';
};

const RegistrationOverviewStep: React.FC<RegistrationOverviewStepProps> = ({
  stepNumber,
  title,
  disabled,
  variant = 'primary'
}) => {
  return (
    <div className={`flex items-center gap-2.5 ${disabled ? 'opacity-40' : ''}`}>
      <span
        className={`flex size-7.5 items-center justify-center rounded-full border text-body-sm ${
          variant === 'success'
            ? 'bg-success text-white'
            : 'border-neutral-fg text-neutral-fg'
        }`}
      >
        {variant === 'success' ? <CheckOutlined aria-hidden /> : stepNumber}
      </span>
      <span className="text-body-sm text-neutral-fg">{title}</span>
    </div>
  );
};

export default RegistrationOverviewStep;
